import util from './shared/util.js';
import config from '../config.js';

var servicesURL = `${config.server.url}:${config.server.webServicesPort}/form/`;

class cdoForm {
    delete = (data, callback) => {
        util.putJSON(servicesURL + 'delete', data, callback);
    }
}

const cdo = new cdoForm();
export default cdo;
